import script from "./CTTPModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CTTPModal.vue?vue&type=script&setup=true&lang=js"

import "./CTTPModal.vue?vue&type=style&index=0&id=1cabac61&lang=scss"

const __exports__ = script;

export default __exports__